import { AioExternalReplacements } from "./interface";
import { newReplacementValues } from "./newReplacementValues";

/**
 * Create a new external replacements with a blank template.
 *
 * @param blankT - The blank text template
 * @returns AioExternalReplacements<T>
 */
export const newExternalReplacements = <T>(blankT: T): AioExternalReplacements<T> => {
  return {
    givenName: "",
    newTexts: [newReplacementValues(blankT)],
  };
};
